import React, { useContext } from "react";
import { Box } from "styles/globalComponents";
import HomeIcon from "Assets/Images/home-icon.png";
import { Info } from "lucide-react";
import { CartItemWithReplacement } from "./CartItemWithReplacement";
import { ItemsContext } from "../../../Provider";

import { NotFoundProduct } from "../../../interface";

interface CartListItemsProps {
  items: any[];
  loadingOperation: number | null;
  addUnitItem: (productId: number) => void;
  removeUnitItem: (productId: number) => void;
  onReplace?: (productId: number) => void;
  notFoundProducts: NotFoundProduct[];
}

export const CartListItems = ({
  items,
  loadingOperation,
  addUnitItem,
  removeUnitItem,
  onReplace,
  notFoundProducts,
}: CartListItemsProps) => {
  const cartContext = useContext(ItemsContext);

  if (!cartContext) {
    return null;
  }

  return items.length >= 1 ? (
    <div className="attendment-list-container">
      <section className="budget-collect-type">
        <Box display="flex" gap="10" align="center">
          <img src={HomeIcon} alt="" />
          <p className="collect-title">
            <strong>ATENDIMENTO DOMICILIAR</strong> <br />
          </p>
        </Box>
      </section>
      <div className="cart-itens-holder new-layout-cart-itens-holder">
        {items.map((item) => (
          <CartItemWithReplacement
            key={item?.product_id}
            product={item}
            addUnitItem={addUnitItem}
            removeUnitItem={removeUnitItem}
            deleteItem={cartContext.deleteItem}
            loadingOp={item.product_id === loadingOperation}
            onReplace={onReplace}
          />
        ))}

        {notFoundProducts.map((product, index) => (
          <div key={index} className="cart-item cart-item-not-found">
            <p className="label">{product.name}</p>
            <span className="ia-tag-container">
              <div className="tooltip-container">
                <Info size={16} className="info-icon" />
                <span className="tooltip-text">
                  Este produto não está disponível para essa ação
                </span>
              </div>
            </span>
          </div>
        ))}
      </div>
    </div>
  ) : null;
};
